import { ActionIcon, Box, Group, Image, Paper, Text } from '@mantine/core'
import { IconFileText, IconX } from '@tabler/icons-react'
import { formatAttachmentSize } from '../chat/chatAttachments'

/** One file staged in the composer, before it is prepared and sent. */
export type ChatAttachmentDraft = {
  id: string
  file: File
  name: string
  isImage: boolean
  /** Object URL for image thumbnails; revoked when the draft is removed. */
  previewUrl?: string
}

export function ChatAttachmentChips({
  attachments,
  onRemove,
  disabled,
}: {
  attachments: readonly ChatAttachmentDraft[]
  onRemove: (id: string) => void
  disabled?: boolean
}) {
  if (!attachments.length) return null
  return (
    <Group gap="xs" wrap="wrap" mb="xs">
      {attachments.map((a) => (
        <Paper key={a.id} withBorder radius="md" p={4} pr={6}>
          <Group gap={6} wrap="nowrap" align="center">
            {a.isImage && a.previewUrl ? (
              <Image src={a.previewUrl} alt={a.name} w={32} h={32} radius="sm" fit="cover" />
            ) : (
              <Box
                w={32}
                h={32}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <IconFileText size={18} />
              </Box>
            )}
            <Box style={{ minWidth: 0, maxWidth: 160 }}>
              <Text size="xs" truncate="end" title={a.name}>
                {a.name}
              </Text>
              <Text size="10px" c="dimmed">
                {formatAttachmentSize(a.file.size)}
              </Text>
            </Box>
            <ActionIcon
              size="sm"
              variant="subtle"
              color="gray"
              aria-label={`Remove ${a.name}`}
              disabled={disabled}
              onClick={() => onRemove(a.id)}
            >
              <IconX size={14} />
            </ActionIcon>
          </Group>
        </Paper>
      ))}
    </Group>
  )
}
